import { Controller } from "@hotwired/stimulus";

const SHIPPING_BASKET_ID_REGEX = /sbid=(.*)$/;

export default class extends Controller {
  static values = {
    fetchMethod: { type: String, default: 'GET' }
  }

  // keep track of how many modals are "in flight"
  initialize() {
    this.requestCount = 0
  }

  showLoadingModal(selector = '#shipping-change-section') {
    this.requestCount++
    if (this.requestCount === 1) {
      $(selector).show()
    }
  }

  hideLoadingModal(selector = '#shipping-change-section') {
    this.requestCount = Math.max(this.requestCount - 1, 0)
    if (this.requestCount === 0) {
      $(selector).hide()
    }
  }

  getShippingBasketId() {
    const ogUrl = $('meta[property="og:url"]').attr('content') || '';
    const match = ogUrl.match(SHIPPING_BASKET_ID_REGEX);
    return match ? match[1] : null;
  }

  buildFetchUrl(baseUrl, params = {}) {
    const sbid = this.getShippingBasketId();
    if (sbid) {
      params.sbid = sbid;
    }
    const query = new URLSearchParams(params).toString();
    return `${baseUrl}?${query}`;
  }

  async fetchJson(url, options = {}) {
    const mergedOptions = Object.assign({ method: this.fetchMethodValue }, options);
    try {
      const response = await fetch(url, mergedOptions);
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("fetchJson error:", error);
      return null;
    }
  }
}
